import { mapDtoList, mapStringList, optionalNumber, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.generator.common.codes.PotentialExistingCode
 *
 * @typedef {object} PotentialExistingCodeData
 * @property {number|null} newSuggestIndex
 * @property {string[]} existingCodeIds
 * @property {string|null} reason
 */

/**
 * @param {object} raw
 * @returns {PotentialExistingCodeData}
 */
export function fromPotentialExistingCodeData(raw) {
  const source = requireObject(raw, 'PotentialExistingCode');
  return {
    newSuggestIndex: optionalNumber(source.newSuggestIndex),
    existingCodeIds: mapStringList(source.existingCodeIds, 'PotentialExistingCode.existingCodeIds'),
    reason: optionalString(source.reason),
  };
}

/**
 * @param {unknown} raw
 * @returns {PotentialExistingCodeData[]}
 */
export function fromPotentialExistingCodeDataList(raw) {
  return mapDtoList(raw, 'PotentialExistingCode', fromPotentialExistingCodeData);
}
